export default "__VITE_ASSET__n4zauKlT__"